import { Root, createRoot } from "react-dom/client";

import { PlayerParams } from "../types/player";
import App from "./../App";

export default class VideoPlayer {
  private elementId: string;
  private root: Root;
  public video: any;

  constructor({ elementId = "root" }: { elementId?: string }) {
    this.elementId = elementId;
    this.root = createRoot(document.getElementById(elementId) as HTMLElement);
  }

  setup(params?: Partial<PlayerParams>) {
    if (this.root) {
      this.root.render(<App props={params} />);
    }

    return this; // 그냥 자기 자신 반환
  }

  getVideo(): Promise<VideoPlayer> {
    return new Promise((resolve) => {
      const handleMount = ({ detail }: any) => {
        this.video = detail;
        window.removeEventListener("sqaudx_player_mount", handleMount);
        resolve(this.video);
      };
      window.addEventListener("sqaudx_player_mount", handleMount);
    });
  }

  private eventHandlers: { event: string; handler: any }[] = [];

  destroy() {
    if (this.video) {
      this.eventHandlers.forEach(({ event, handler }) => {
        this.video.removeEventListener(event, handler);
      });
      this.eventHandlers = [];
    }
    if (this.root) {
      this.root.unmount();
    }
  }

  private getInfo() {
    if (!this.video) return { duration: 0, percent: 0, seconds: 0 };
    const { duration, currentTime } = this.video;
    return {
      duration,
      percent: duration > 0 ? (currentTime / duration) * 100 : 0,
      seconds: currentTime,
    };
  }

  private addListener(event: string, callback: (info: any) => void) {
    if (this.video) {
      const handler = () => callback(this.getInfo());
      this.video.addEventListener(event, handler);
      this.eventHandlers.push({ event, handler });
    }
  }

  on(event: string, callback: (info: any) => void) {
    let targetEvent = event;
    if (event === "load") {
      targetEvent = "loadedmetadata";
  }
    this.addListener(targetEvent, callback);
  }


  load(params: Partial<PlayerParams>) {
    this.setup(params);
  }

  play() {
    if (this.video) {
      this.video.play();
    }
  }

  pause() {
    if (this.video) {
      this.video.pause();
    }
  }


  seek(time: number) {
    if (this.video) {
      this.video.currentTime = time;
    }
  }

}
